<template>
    <div class="category"
        :class="{'selected': selected, 'unselected': !selected, 'disabled': disabled}"
        @click="$emit('click')"> 
        {{label}} <i :class="!disabled && selected ? 'icon-close': ''"></i>
    </div>
</template>

<script>
export default {
    props: {
        selected: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        label: {
            type: String
        }
    }
}
</script>

<style scoped>
.category.selected {
    display: inline-block;
    color: #5A4BB0;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #eceeff;
    margin-bottom: 8px;
}

.category.unselected:not(.disabled){
    display: inline-block;
    color: #484848;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
}
</style>